import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { add, find } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Address, Cliente } from 'src/app/shared/Interfaces/customer';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { Company, ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { GeolocationService, Coordinates, addressGoogle} from 'src/app/shared/services/GeoLocation/geolocation.service';
import { EventsService } from 'src/app/shared/services/events/events.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css', "../../../assets/styles/global/_modal.scss"]
})
export class AddressComponent implements OnInit, AfterViewInit{
  @ViewChild('modalOptions') modalOptions!: ElementRef;

  private idAddress = '';
  private AddressEditing!: Address

  optionHome = {checked: false, value: 'Casa'}
  optionWork = {checked: false, value: 'Trabalho'}
  optionSchool = {checked: false, value: 'Escola'}

  company!: Company;
  showTopMenu = true;
  openModalAskTitle = false;
  showAddress = false;
  showLoading = false;
  showInput = false;
  cep: string = '';
  coordinates!: Coordinates
  addressGoogle!: addressGoogle
  user!: Cliente;
  nameCompany: string = '';
  requestApi = false;
  selectedAddressIdenfier!: string;
  listLocalization: any = [];
  sucessLocalization: boolean = false;
  id_company: string = '';
  notNumber: boolean = false;
  
  
  
  address: Address = {
    country: '',
    state: '',
    city: '',
    neighborhood: '',
    street: '',
    postalCode: '',
    number: '',
    complement: '',
    reference: '',
    identifier: '',
    id_address: '',
    deliveryPrice: 0,
    deliverydistance: 0
  };

  addressCep!: Address;

  //Bairros
  searchNeighborhood: string = '';
  filteredNeighborhoods: any[] = [];
  neighborhoods: any[] = []
  openOptions: boolean = false;
  invalidNeighborhood: boolean = false;

  //Estados
  searchState: string = '';
  invalidState: boolean = false;
  filteredStates: any[] = []
  openOptionsState: boolean = false;
  states: string[] = [
  'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT',
  'MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO',
  'RR','SC','SP','SE','TO'
  ];

  //Cidade
  statesAndCities: any[] = [];
  cities: any[] = [];
  searchCity: string = '';
  filteredCities: string[] = [];
  openOptionsCity: boolean = false;
  invalidCity: boolean = false;

  constructor(
    private router: Router,
    private connection: ConnectionService,
    private apiService: ApiService,
    private geolocation: GeolocationService,
    private layout: LayoutComponent,
    private eventsService: EventsService,
    private cacheService: CacheService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    // private toastr: ToastrService,
    private notify: NotificationService,
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    ){
    this.showLoading = true;
    this.connection.nameCompany$.subscribe((newNameCompany) => {
      this.nameCompany = newNameCompany;
    })
    this.connection.company$.subscribe((data) =>{
      if(data){
        this.company = data;
        this.id_company = data.company.id_company;
        if(this.company.configs.cep == 0){
          this.requestApi = true;
        }
        
      }
    })

    this.geolocation.id_Address$.subscribe((newAddress) =>{
      if(newAddress){
        this.AddressEditing = newAddress;
        
        if(this.AddressEditing.identifier == 'Casa'){
          this.optionHome = {checked: true, value: 'Casa'}
        }
        else if(this.AddressEditing.identifier == 'Casa'){
          this.optionWork = {checked: true, value: 'Trabalho'}
        }
        else if(this.AddressEditing.identifier == 'Trabalho'){
          this.optionSchool = {checked: true, value: 'Escola'}
        }
      }
    })


    this.checkScreenSize();
  }

  ngOnInit(): void {
    this.getCities();

    this.getNeighborhood(this.id_company);

    this.disablePullToRefresh();

    this.connection.user$.subscribe(
      (User) =>
      {
        this.user = User;
      },
      (error) =>{
        if(this.cacheService.getItemLocal('user_key'))
        {
          this.user = this.cacheService.getItemLocal('user_key');
        }
      }
    )

    this.eventsService.eventNavegationSubject.next(true);

    if(this.AddressEditing){
      this.address = this.AddressEditing;

      if(this.address.number == ''){
        this.notNumber = true;
      }
      this.requestApi = true;
    }
    else{
      const foundUF = this.states.find((state) => state == this.company.company.address.state)
      if(foundUF){
        this.searchState = foundUF;
        this.address.state = foundUF;
      }
      
    }

    if(this.company.configs.deliveryType == 0){
      this.invalidNeighborhood = false;
    }

    //Carrega a lista de filtro com os estados
    this.filteredStates = this.states;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showLoading = false;
    }, 500);
  }

  //#region Style

    changeCheckBox(event: any){
      const value = event.target.checked;

      this.notNumber = value;

      if(value == true){
        this.address.number = '';
      }
    }

    //Valida o formulário para ativar o botão
    validForm(): boolean {
      const { number = '', city = '', neighborhood = '', street = '', state = ''} = this.address || {};

      const validText = /[a-zA-Z0-9À-ÿ]/; 

      const fieldsValid =
          city.trim().length > 3 && validText.test(city) &&
          neighborhood.trim().length >= 3 && validText.test(neighborhood) &&
          street.trim().length > 3 && validText.test(street) &&
          state.trim().length == 2 && validText.test(state);

      const numberValid = (number.toString() !== '' && number.toString() !== '0' && validText.test(number)) || this.notNumber;

      return fieldsValid && numberValid && !this.invalidNeighborhood && !this.invalidState && !this.invalidCity;
    }

    //Abre o modal para definir uma identificação ao endereço
    openModalAddress(){
      const inValid = this.validForm()
      if(inValid){
        this.openModalAskTitle = true;
        this.disableScroll();
      }

    }

    //Filtra o input do CEP retirando os caracteres que não são números
    filterInput(value: string) {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 8);
      this.cep = digitsOnly;
    }

    //Abilita o scroll da pagina
    enableScroll(){
      this.renderer.removeStyle(this.document.body, 'overflow');
    }

    //Desabilita o scroll
    disableScroll(){
      this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
    }

    //Função responsavel por travar de o scroll para que a tela não seja recarregada no menu
    disablePullToRefresh() {
      const element = this.elementRef.nativeElement;
      let isAtTop = true;

      // Adiciona um ouvinte para o evento de scroll
      this.renderer.listen(window, 'scroll', () => {
        // Verifica se a página está no topo
        isAtTop = window.scrollY === 0;
      });

      this.renderer.listen(element, 'touchstart', (event) => {
        // Registra a posição inicial do toque
        const startY = event.touches[0].clientY;

        // Adiciona um ouvinte para o evento de movimento de toque
        const touchMoveListener = this.renderer.listen(element, 'touchmove', (moveEvent) => {
          // Calcula a diferença entre a posição inicial e a posição atual
          const deltaY = moveEvent.touches[0].clientY - startY;

          // Se a diferença for positiva (movimento para baixo) e a página estiver no topo, previne o comportamento padrão
          if (deltaY > 0 && isAtTop) {
            moveEvent.preventDefault();
          }
        });

        // Adiciona um ouvinte para o evento de término de toque
        const touchEndListener = this.renderer.listen(element, 'touchend', () => {
          // Remove os ouvintes após o término do toque
          touchMoveListener();
          touchEndListener();
        });
      });
    }

    //Verifica o tamanho da tela, esconde o Menu superior se necessario
    private checkScreenSize(){
      if(window.innerWidth <= 846){

        this.showTopMenu = false;
      }
      else{
        this.showTopMenu = true;
      }
      this.layout.checkScreenSize();
    }

    //Resgata os eventos de resize da tela.
    @HostListener('window:resize', [])
    onWindowResize() {
      this.checkScreenSize();
    }

    //Resgata os eventos de clique na view
    @HostListener('document:click', ['$event'])
    clickOutside(event: MouseEvent) {
      const target = event.target as HTMLElement;

      // Fecha somente se clicar fora do respectivo select
      if (!target.closest('#state-select')) {
        this.openOptionsState = false;
      }

      if (!target.closest('#city-select')) {
        this.openOptionsCity = false;
      }

      if (!target.closest('#generic-select')) {
        this.openOptions = false;
      }
    }

  //#endregion

  //#region Logic

    //Resgata uma lista dos estados contendo as cidades dentro.
    getCities(){
      this.apiService.getCitysForState('ALL').subscribe(
        (data) => {
          this.statesAndCities = data.statesAndCities;

          if(this.address.state != ''){
            this.alterationListCities(this.address.state);
          }

          if (this.AddressEditing) {
            this.validateFullAddress();
          }
        },
        (error) =>{
          console.log(error)
        }
      )
    }

    //Resgata os bairros cadastrados
    getNeighborhood(id_company: string) {
      this.apiService.getNeighborhood(id_company).subscribe (
        (data) => {
          this.neighborhoods = data.response.neighborhood;
          this.filteredNeighborhoods = this.neighborhoods;

          if (this.AddressEditing && this.company.configs.deliveryType == 1) {
            this.validateFullAddress();
          }
        },
        (error) => {
          console.log(error)
        }
      )
    }

    //Valida os campos de Bairro, Cidade e Estado
    validateFullAddress() {
      // === ESTADO ===
      const foundState = this.states.find((state) => this.address.state === state);
      if (!foundState) {
        this.address.state = '';
        this.searchState = '';
        this.invalidState = true;
        this.cities = [];
        this.filteredCities = [];
        return; // não adianta prosseguir sem estado válido
      }
      this.address.state = foundState;
      this.searchState = foundState;
      this.invalidState = false;

      // Atualiza as cidades desse estado
      this.alterationListCities(foundState);

      // === CIDADE ===
      const foundCity = this.cities.find(
        (city) => city.toLowerCase() === this.address.city.toLowerCase()
      );
      if (!foundCity) {
        this.address.city = '';
        this.searchCity = '';
        this.invalidCity = true;
      } else {
        this.address.city = foundCity;
        this.searchCity = foundCity;
        this.invalidCity = false;
      }

      // === BAIRRO ===
      if (this.company.configs.deliveryType === 1) {
        const foundNeighborhood = this.neighborhoods.find(
          (bairro) =>
            bairro.neighborhood.toLowerCase() ===
            this.address.neighborhood.toLowerCase()
        );

        if (!foundNeighborhood) {
          this.address.neighborhood = '';
          this.searchNeighborhood = '';
          this.invalidNeighborhood = true;
        } else {
          this.address.neighborhood = foundNeighborhood.neighborhood;
          this.searchNeighborhood = foundNeighborhood.neighborhood;
          this.invalidNeighborhood = false;
        }
      }
    }

    //Volta para view anterior
    goback(): void{
      this.geolocation.id_AddressSubject.next(undefined)
      this.router.navigate([this.nameCompany, 'order-confirmation']);
    }

    //Identificação customizavel do endereço
    selectIdentifier(nameIdentifier: string){
      this.selectedAddressIdenfier = nameIdentifier;
      this.address.identifier = nameIdentifier;
      this.changeDetectorRef.detectChanges();
    }

    //Seleciona uma Idenficiação padrão ao endereço
    onCheckboxChange(data: { checked: boolean, value: any }) {
      // this.selectedOption = { checked: data.checked, value: data.value};
      if(data.checked){
        if(data.value == 'Casa'){
          this.optionSchool.checked = false;
          this.optionWork.checked = false;
        }
        else if(data.value == 'Trabalho')
        {
          this.optionHome.checked = false;
          this.optionSchool.checked = false;
        }
        else if(data.value == 'Escola')
        {
          this.optionHome.checked = false;
          this.optionWork.checked = false;
        }

        this.selectIdentifier(data.value)
      }
      else{
        this.address.identifier = ''
      }
    }

    //Resgata a localização exata 
    getLocalization(){
      this.listLocalization = []
      this.showLoading = true;
      this.geolocation.getLocation().then((coords)=>{
        this.coordinates = coords;

        this.geolocation.getLocalizationReal(this.coordinates.latitude, this.coordinates.longitude).subscribe(
          (response) =>{
            if(response)
            {
              response.results.forEach((result: any) => {
                const components = result.address_components;
                
                const address: Address = {
                  number: this.getAddressComponent(components, 'street_number'), // Número
                  street: this.getAddressComponent(components, 'route'), // Rua
                  neighborhood: this.getAddressComponent(components, 'sublocality') || this.getAddressComponent(components, 'sublocality_level_1'), // Bairro
                  city: this.getAddressComponent(components, 'administrative_area_level_2'), // Cidade
                  state: this.getAddressComponent(components, 'administrative_area_level_1', true), // Estado
                  country: this.getAddressComponent(components, 'country'), // Pais
                  postalCode: this.getAddressComponent(components, 'postal_code'), //Código postal  
                  complement: '',
                  reference: '',
                  identifier: '',
                  id_address: '',
                  deliveryPrice: 0,
                  deliverydistance: 0
                }

                this.listLocalization.push(address);

              });

              this.sucessLocalization = true;

              this.showLoading = false;
            }
          },
          (error) =>{
            console.error('Erro ao tentar fazer o request', error)
            this.notify.error('Não conseguimos encontrar sua localização');
            this.showLoading = false;
        })
      },
      (error) =>{
        this.notify.error('Não conseguimos encontrar sua localização!')
        console.log(error)
        this.showLoading = false;
      }).catch((error) => console.error('Error getting location:', error));


    }

    //Resgata os campos do endereço pelo tipo dele no googgle
    getAddressComponent(components: any[], type: string, short = false): string {
      const comp = components.find(c => c.types.includes(type));
      return comp ? (short ? comp.short_name : comp.long_name) : '';
    }

    //Realiza a busca do cep e carrega o objeto
    getLocalizationCEP(event: any){
      const value = event.target.value.replace(/\D/g, '').slice(0, 8);
      const length = event.target.value.length

      if(length == 8){
        this.showAddress = false
        this.showLoading = true;
        this.geolocation.getCep(Number(value)).subscribe(
          (data) =>{
            if(data){

              if(data.erro){
                this.notify.error('Atenção<br>Cep não encontrado.')
                // this.toastr.warning('Cep não encontrado!', 'Atenção', { positionClass: 'toast-top-right', timeOut: 1500});
                this.showLoading = false;
                return;
              }

              console.log(data)

              let street = data.logradouro.split('-');
              let streetFormatted  = street[0].trim();
              let cepFormatted = data.cep.replace(/\D/g, '')

              const address: Address = {
                country: 'Brasil',
                state: data.uf,
                city: data.localidade,
                neighborhood: data.bairro,
                street: streetFormatted,
                postalCode: cepFormatted,
                number: '',
                complement: '',
                reference: '',
                identifier: '',
                id_address: '',
                deliveryPrice: 0,
                deliverydistance: 0
              }
              this.cep = cepFormatted
              // const address: Address = {
              //   country: 'Brasil',
              //   state: data.state,
              //   city: data.city,
              //   neighborhood: data.neighborhood,
              //   street: streetFormatted,
              //   postalCode: data.cep,
              //   number: '',
              //   complement: '',
              //   reference: '',
              //   identifier: '',
              //   id_address: '',
              //   deliveryPrice: 0,
              //   deliverydistance: 0
              // }
              // this.address = address
              this.addressCep = address;

              setTimeout(() => {
                this.showLoading = false;
                this.showAddress = true;
              }, 1000);

            }

          },
          (error) =>{
            console.error('Erro ao tentar fazer o request', error)
            this.requestApi = true;
            this.showLoading = false;
          })
      }
    }

    //Atribui o endereço via localização ao Objeto e abre a view do endereço
    openLocalization(address: any){
      this.address = address;
      this.requestApi = true;
      this.sucessLocalization = false;

      if (this.company.configs.deliveryType == 1) {
        this.invalidNeighborhood = true; // até validar
      }

      this.validateFullAddress();
    }

    //Atribui o endereço via Cep ao Objeto e abre a view do endereço
    openLocalizationCEP(){
      this.address = this.addressCep;
      this.requestApi = true;

      if (this.company.configs.deliveryType == 1) {
        this.invalidNeighborhood = true; // até validar
      }

      this.validateFullAddress();
    }

    //#region Bairro

      //Abre o select para selecionar os bairros
      openOptionsNeighborhood() {
        this.openOptions = !this.openOptions

        if(this.openOptions) {
          setTimeout(() => {
            this.modalOptions.nativeElement.focus();
          }, 100);
        }
      }

      //Filtra os bairros
      filterNeighborhoods() {
        this.filteredNeighborhoods = this.filterAndValidate( this.searchNeighborhood, this.neighborhoods,
          (bairro) => bairro.neighborhood,

          (validNeighborhood) => {
            this.address.neighborhood = validNeighborhood.neighborhood;
            this.invalidNeighborhood = false;
          },
          
          () => {
            this.address.neighborhood = '';
            this.invalidNeighborhood = true;
          }
        );
      }

      //Seleciona os bairros
      selectNeighborhood(neighborhood: string) {
        this.address.neighborhood = neighborhood;
        this.searchNeighborhood = neighborhood;
        this.invalidNeighborhood = false;
        this.openOptions = false;
      }
    
    //#endregion

    //#region Cidade

      // Filtra as cidades ao digitar
      filterCities() {
        this.filteredCities = this.filterAndValidate(
          this.searchCity,
          this.cities,
          (city) => city,
          (validCity) => {
            this.address.city = validCity;
            this.invalidCity = false;
          },
          () => {
            this.address.city = '';
            this.invalidCity = true;
          }
        );
      }

      // Seleciona a cidade ao clicar
      selectCity(city: string) {
        this.address.city = city;
        this.searchCity = city;
        this.invalidCity = false;
        this.openOptionsCity = false;
      }

      //Altera a lista de cidade de acordo com o UF/Estado
      alterationListCities(uf: string){
        if(this.statesAndCities && this.statesAndCities.length != 0){
          const findState = this.statesAndCities.find((state) => state.uf === uf);
          this.cities = findState ? findState.cities : [];
          this.filteredCities = this.cities;

          if(this.searchCity != ''){
            this.address.city = '';
            this.filterCities()
          }
        }
      }

    //#endregion

    //#region Estado

      //Filtra os estados
      filterStates() {
        this.searchState = this.searchState.toUpperCase();

        this.filteredStates = this.filterAndValidate(
          this.searchState,
          this.states,
          (state) => state,
          (validState) => {
            this.address.state = validState;
            this.invalidState = false;
            this.alterationListCities(validState); // já carrega as cidades
          },
          () => {
            this.address.state = '';
            this.invalidState = true;
            this.filteredCities = [];
          }
        );
      }

      //Seleciona os estados
      selectState(state: string) {
        this.address.state = state;
        this.searchState = state;
        this.invalidState = false;
        this.openOptionsState = false;
        this.alterationListCities(this.searchState);
      }
    //#endregion

    //Função global para filtrar e validar meus campos de Bairro, Cidade e Estado
    private filterAndValidate<T>(term: string, list: T[], compareFn: (item: T) => string, onValid: (validItem: T) => void, onInvalid: () => void): T[] {
      const lowerTerm = term.toLowerCase();

      // Filtra lista
      const filtered = list.filter(item =>
        compareFn(item).toLowerCase().includes(lowerTerm)
      );

      // Verifica se o valor digitado corresponde exatamente a um item
      const found = list.find(
        item => compareFn(item).toLowerCase() === lowerTerm
      );

      if (found) {
        onValid(found);
      } else {
        onInvalid();
      }

      return filtered;
    }

    //Realiza a requisição de Criação ou edição do endereço POST | PATCH
    submitAddress(){
      if(this.AddressEditing != undefined){
        this.address.deliveryPrice = 0
        delete this.address.formattedaddress
        this.apiService.pathAddress(this.user.id_customer, this.address).subscribe((data) =>{
          this.geolocation.id_AddressSubject.next(undefined)
          this.connection.updateUser(data.response)
          this.cacheService.setItemLocal('user_key', data.response)
          this.notify.success('Endereço editado com sucesso!')
          this.router.navigate([ this.nameCompany, 'order-confirmation'])
        },
        (error) =>{
          this.notify.error('Falha ao editar o endereço!')
        });
      }
      else{
        this.apiService.postAddress(this.user.id_customer, this.address).subscribe((response) =>{
          this.connection.updateUser(response.response)
          this.cacheService.setItemLocal('user_key', response.response)
          this.cacheService.removeItemLocal('userAddress')
          this.openModalAskTitle = false;
          this.notify.success('Endereço cadastrado com sucesso!')
          this.router.navigate([ this.nameCompany, 'order-confirmation'])
        },
        (error) =>{
          this.notify.error('Falha ao cadastrar o endereço!')
        });
      }
      this.enableScroll()
    }

    get pageTitle(): string {
      return this.AddressEditing ? 'Editar endereço' : 'Novo endereço';
    }

  //#endregion
}
